const IBANKING_CHANNEL = 'ibanking-channel';
const setIBankingChannel = (channel) => {
    localStorage.setItem(IBANKING_CHANNEL, channel || '');
};
const isIBankingIFrame = () => {
    return (typeof window !== 'undefined' && !!localStorage.getItem(IBANKING_CHANNEL));
};

export { isIBankingIFrame, setIBankingChannel };
